import * as tslib_1 from "tslib";
import { environment } from "src/environments/environment";
import * as i0 from "@angular/core";
var EmailEncryptionService = /** @class */ (function () {
    function EmailEncryptionService() {
        this.secretKey = "" + environment.secretKey;
    }
    EmailEncryptionService.prototype.xorEncryptDecrypt = function (text, key) {
        var result = "";
        for (var i = 0; i < text.length; i++) {
            var charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
            result += String.fromCharCode(charCode);
        }
        return result;
    };
    EmailEncryptionService.prototype.stringToBase64 = function (str) {
        return btoa(str);
    };
    EmailEncryptionService.prototype.base64ToString = function (base64) {
        return atob(base64);
    };
    EmailEncryptionService.prototype.addPadding = function (text) {
        var randomPrefix = Math.random().toString(36).substring(2, 8);
        var randomSuffix = Math.random().toString(36).substring(2, 8);
        return randomPrefix + "|" + text + "|" + randomSuffix;
    };
    EmailEncryptionService.prototype.removePadding = function (paddedText) {
        var parts = paddedText.split("|");
        return parts.length === 3 ? parts[1] : paddedText;
    };
    EmailEncryptionService.prototype.encryptEmail = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var keyBuffer, cryptoKey, iv, encodedEmail, encrypted, combined, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        keyBuffer = new TextEncoder().encode(this.secretKey);
                        return [4 /*yield*/, crypto.subtle.importKey("raw", keyBuffer, { name: "AES-GCM" }, false, ["encrypt"])];
                    case 1:
                        cryptoKey = _a.sent();
                        iv = crypto.getRandomValues(new Uint8Array(12));
                        encodedEmail = new TextEncoder().encode(email);
                        return [4 /*yield*/, crypto.subtle.encrypt({ name: "AES-GCM", iv: iv }, cryptoKey, encodedEmail)];
                    case 2:
                        encrypted = _a.sent();
                        combined = new Uint8Array(iv.length + encrypted.byteLength);
                        combined.set(iv);
                        combined.set(new Uint8Array(encrypted), iv.length);
                        // Convert to base64
                        return [2 /*return*/, btoa(String.fromCharCode.apply(null, Array.from(combined)))];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Encryption failed:", error_1);
                        throw new Error("Failed to encrypt email");
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EmailEncryptionService.prototype.decryptEmail = function (encryptedBase64) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var keyBuffer, cryptoKey, combined, iv, encryptedData, decrypted, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        keyBuffer = new TextEncoder().encode(this.secretKey);
                        return [4 /*yield*/, crypto.subtle.importKey("raw", keyBuffer, { name: "AES-GCM" }, false, ["decrypt"])];
                    case 1:
                        cryptoKey = _a.sent();
                        combined = new Uint8Array(atob(encryptedBase64)
                            .split("")
                            .map(function (char) { return char.charCodeAt(0); }));
                        iv = combined.slice(0, 12);
                        encryptedData = combined.slice(12);
                        return [4 /*yield*/, crypto.subtle.decrypt({ name: "AES-GCM", iv: iv }, cryptoKey, encryptedData)];
                    case 2:
                        decrypted = _a.sent();
                        return [2 /*return*/, new TextDecoder().decode(decrypted)];
                    case 3:
                        error_2 = _a.sent();
                        console.error("Decryption failed:", error_2);
                        throw new Error("Failed to decrypt email");
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EmailEncryptionService.prototype.encryptEmailSimple = function (email) {
        var paddedEmail = this.addPadding(email);
        var encrypted = this.xorEncryptDecrypt(paddedEmail, this.secretKey);
        return this.stringToBase64(encrypted);
    };
    EmailEncryptionService.prototype.decryptEmailSimple = function (encryptedBase64) {
        try {
            var encrypted = this.base64ToString(encryptedBase64);
            var paddedEmail = this.xorEncryptDecrypt(encrypted, this.secretKey);
            var checkEmailFormat = this.isValidEmail(this.removePadding(paddedEmail));
            if (checkEmailFormat) {
                return this.removePadding(paddedEmail);
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;
        }
    };
    EmailEncryptionService.prototype.isValidEmail = function (email) {
        var emailRegex = /^[\w.-]+@[\w.-]+\.\w{2,4}$/;
        return emailRegex.test(email);
    };
    EmailEncryptionService.prototype.decryptFormValue = function (encryptedBase64) {
        try {
            var encrypted = this.base64ToString(encryptedBase64);
            var paddedEmail = this.xorEncryptDecrypt(encrypted, this.secretKey);
            return this.removePadding(paddedEmail);
        }
        catch (error) {
            return null;
        }
    };
    EmailEncryptionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmailEncryptionService_Factory() { return new EmailEncryptionService(); }, token: EmailEncryptionService, providedIn: "root" });
    return EmailEncryptionService;
}());
export { EmailEncryptionService };
